import { render, staticRenderFns } from "./ImageIndex.vue?vue&type=template&id=278050b3"
import script from "./ImageIndex.vue?vue&type=script&lang=ts"
export * from "./ImageIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports